import { useEffect, useState } from "react";
import Header from "./Header";

function Membership() {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [markFilter, setMarkFilter] = useState("All");
  const profilesPerPage = 10;
  const [searchQuery, setSearchQuery] = useState("");
  const [memberships, setMemberships] = useState([]);

  const handleSearch = () => {
    setSearchQuery(searchTerm);
  };

  const fetchMemberships = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        "https://xqk5c9abna.execute-api.ap-south-1.amazonaws.com/prod/membership/GetAllMembership",
        {
          headers: {
            Authorization: token,
          },
        }
      );
      const data = await response.json();
      setMemberships(data);
    } catch (error) {
      console.error("Error fetching memberships:", error);
    }
  };

  useEffect(() => {
    fetchMemberships();
  }, []);

  const filteredProfiles = memberships.filter((profile) => {
    const matchesGender =
      markFilter === "All" ||
      profile.gender?.toLowerCase() === markFilter.toLowerCase();

    const matchesSearch =
      searchQuery.trim() === "" ||
      Object.values(profile)
        .concat(Object.values(profile.profile || {}))
        .some((val) =>
          val?.toString().toLowerCase().includes(searchQuery.toLowerCase())
        );

    return matchesGender && matchesSearch;
  });

  const totalPages = Math.ceil(filteredProfiles.length / profilesPerPage);
  const startIndex = (currentPage - 1) * profilesPerPage;
  const currentProfiles = filteredProfiles.slice(
    startIndex,
    startIndex + profilesPerPage
  );

  const handlePrevious = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  useEffect(() => {
    setCurrentPage(1);
  }, [markFilter]);

  const [formData, setFormData] = useState({
    plan: "",
    duration: null,
    durationTitle: "",
    planDescription: "",
    category: "",
    actualPrice: "",
    offerPrice: "",
    discountPercent: "",
    sendRequestLimit: "",
    profileUnlockLimit: "",
    profileVisitLimit: "",
    crownBadgeProfile: false,
    dedicatedSupport: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleAddMembership = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem("token");
      const dataToSend = {
        ...formData,
        duration: Number(formData.duration) * 30 * 24 * 60 * 60 * 1000,
      };

      const response = await fetch(
        "https://xqk5c9abna.execute-api.ap-south-1.amazonaws.com/prod/membership/AddMembership",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },

          body: JSON.stringify(dataToSend),
        }
      );

      if (!response.ok) throw new Error("Failed to add membership");

      alert("Membership added successfully!");
      document.getElementById("addMembershipModal").classList.remove("show");
      document.body.classList.remove("modal-open");
      document.querySelector(".modal-backdrop")?.remove();

      fetchMemberships();
    } catch (err) {
      console.error(err);
      alert("Error adding membership");
    }
  };

  const handleDeleteMembership = async (id) => {
    if (!window.confirm("Are you sure you want to delete this membership?"))
      return;

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `https://xqk5c9abna.execute-api.ap-south-1.amazonaws.com/prod/membership/DeleteMembership?id=${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: token,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to delete membership");

      alert("Membership deleted successfully.");
      fetchMemberships();
    } catch (error) {
      console.error("Error deleting membership:", error);
      alert("Error deleting membership");
    }
  };

  return (
    <>
      <Header />
      <div className="container py-3">
        <div className="row g-2">
          <div className="col-8">
            <div class="table-responsive border-0 overflow-y-hidden bg-white rounded-4">
              <table class="table mb-0 text-nowrap table-centered">
                <thead class="bg-dark">
                  <tr>
                    <th className="w-10 text-white">No.</th>
                    <th className="lh-1 w-60 text-white">
                      Details
                      <i className="bi bi-info-circle ms-2 text-white"></i>
                    </th>
                    <th className="lh-1 w-30 text-white">
                      Action
                      <i className="bi bi-person-gear ms-2 text-white"></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentProfiles.map((profile, index) => (
                    <tr key={startIndex + index} className="bg-white-light">
                      <td>{startIndex + index + 1}.</td>
                      <td className="lh-sm py-4">
                        <span class="text-dark">Plan ID</span> &mdash;{" "}
                        {profile._id}
                        <br />
                        <span class="text-dark">Plan Name</span> &mdash;{" "}
                        {profile.plan}
                        <br />
                        <span class="text-dark">Duration</span> &mdash;{" "}
                        {profile.durationTitle}
                        <br />
                        <span class="text-dark">
                          Plan Description
                        </span> &mdash;{" "}
                        {profile.planDescription
                          .split(" ")
                          .reduce((acc, word, index) => {
                            const last = acc.length - 1;
                            if (index % 4 === 0) {
                              acc.push([word]);
                            } else {
                              acc[last].push(word);
                            }
                            return acc;
                          }, [])
                          .map((group, i) => (
                            <span key={i}>
                              {group.join(" ")}
                              <br />
                            </span>
                          ))}
                        <br />
                        <span class="text-dark">Category</span> &mdash;{" "}
                        {profile.category} <br />
                        <span class="text-dark">Actual Price</span> &mdash;{" "}
                        {profile.actualPrice}
                        <br />
                        <span class="text-dark">Offer Price</span> &mdash;{" "}
                        {profile.offerPrice}
                        <br />
                        <span class="text-dark">
                          Discount Percent
                        </span> &mdash; {profile.discountPercent}
                        <br />
                        <span class="text-dark">Send Request Limit</span>{" "}
                        &mdash; {profile.sendRequestLimit}
                        <br />
                        <span class="text-dark">Profile Unlock Limit</span>{" "}
                        &mdash; {profile.profileUnlockLimit}
                        <br />
                        <span class="text-dark">Profile Visit Limit</span>{" "}
                        &mdash; {profile.profileVisitLimit}
                        <br />
                        <span class="text-dark">Crown Badge Profile</span>{" "}
                        &mdash; {profile.crownBadgeProfile}
                        <br />
                        <span class="text-dark">Profile Unlock Limit</span>{" "}
                        &mdash; {profile.profileUnlockLimit}
                        <br />
                        <span class="text-dark">
                          Dedicated Support
                        </span> &mdash; {profile.profileUnlockLimit}
                        <br />
                        <span class="text-dark">Created At</span> &mdash;{" "}
                        {new Date(profile.createdAt).toLocaleString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })}
                      </td>
                      <td>
                        <div className="d-flex flex-column gap-1">
                          <span
                            className="badge bg-danger-soft cursor-pointer px-7 rounded-3 w-75"
                            onClick={() => handleDeleteMembership(profile._id)}
                          >
                            Delete
                          </span>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="col-4">
            <div className="bg-danger-soft rounded-4 p-5">
              <div className="d-flex bg-white justify-content-between rounded-pill mb-2">
                <form
                  className="d-flex align-items-center"
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSearch();
                  }}
                >
                  <span className="position-absolute ps-3 search-icon">
                    <i className="bi bi-filter-circle-fill ms-1" />
                  </span>
                  <input
                    type="search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="form-control ps-7 rounded-3 border-0 rounded-pill"
                    placeholder="Filter Data"
                  />
                </form>
                <span
                  onClick={handleSearch}
                  class="btn btn-warning px-5 fs-6 fw-semibold rounded-pill fit-content"
                >
                  Search
                </span>
              </div>

              <button
                type="button"
                className="btn btn-success rounded-pill px-5 fs-6 mb-3"
                data-bs-toggle="modal"
                data-bs-target="#addMembershipModal"
              >
                Add Membership
              </button>

              {memberships.length === 0 && <div>No memberships found.</div>}

              <h3 className="m-0 lh-sm">All Memberships</h3>
              <p>Membership live so far</p>
              <p className="fw-medium text-dark mb-2">
                {filteredProfiles.length} Membership
                {filteredProfiles.length !== 1 ? "s" : ""}
              </p>

              <hr className="border-light" />

              <div className="d-flex justify-content-between align-items-center mt-3">
                <button
                  className="btn btn-outline-dark rounded-4"
                  disabled={currentPage === 1}
                  onClick={handlePrevious}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>
                <span className="text-dark">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  className="btn btn-outline-dark rounded-4"
                  disabled={currentPage === totalPages}
                  onClick={handleNext}
                >
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="addMembershipModal"
        tabIndex="-1"
        aria-labelledby="addMembershipModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <form onSubmit={handleAddMembership}>
              <div className="modal-header">
                <h5 className="modal-title" id="addMembershipModalLabel">
                  Add New Membership
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="row g-2">
                  <div className="col-6">
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="Plan Name"
                      name="plan"
                      value={formData.plan}
                      onChange={handleChange}
                    />
                    <input
                      type="number"
                      className="form-control mb-2"
                      placeholder="Duration (months)"
                      name="duration"
                      value={formData.duration}
                      onChange={handleChange}
                    />
                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="Duration Title"
                      name="durationTitle"
                      value={formData.durationTitle}
                      onChange={handleChange}
                    />

                    <textarea
                      className="form-control mb-2"
                      placeholder="Plan Description"
                      name="planDescription"
                      value={formData.planDescription}
                      onChange={handleChange}
                    />

                    <input
                      type="text"
                      className="form-control mb-2"
                      placeholder="Category"
                      name="category"
                      value={formData.category}
                      onChange={handleChange}
                    />

                    <input
                      type="number"
                      className="form-control mb-2"
                      placeholder="Actual Price"
                      name="actualPrice"
                      value={formData.actualPrice}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-6">
                    <input
                      type="number"
                      className="form-control mb-2"
                      placeholder="Offer Price"
                      name="offerPrice"
                      value={formData.offerPrice}
                      onChange={handleChange}
                    />

                    <input
                      type="number"
                      className="form-control mb-2"
                      placeholder="Discount Percent"
                      name="discountPercent"
                      value={formData.discountPercent}
                      onChange={handleChange}
                    />
                    <input
                      type="number"
                      className="form-control mb-2"
                      placeholder="Send Request Limit"
                      name="sendRequestLimit"
                      value={formData.sendRequestLimit}
                      onChange={handleChange}
                    />

                    <input
                      type="number"
                      className="form-control mb-2"
                      placeholder="Profile Unlock Limit"
                      name="profileUnlockLimit"
                      value={formData.profileUnlockLimit}
                      onChange={handleChange}
                    />

                    <input
                      type="number"
                      className="form-control mb-2"
                      placeholder="Profile Visit Limit"
                      name="profileVisitLimit"
                      value={formData.profileVisitLimit}
                      onChange={handleChange}
                    />

                    <div className="form-check mb-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="crownBadgeProfile"
                        checked={formData.crownBadgeProfile}
                        onChange={handleChange}
                        id="crownBadgeProfile"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="crownBadgeProfile"
                      >
                        Crown Badge Profile
                      </label>
                    </div>

                    <div className="form-check mb-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="dedicatedSupport"
                        checked={formData.dedicatedSupport}
                        onChange={handleChange}
                        id="dedicatedSupport"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="dedicatedSupport"
                      >
                        Dedicated Support
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary fs-6 rounded-pill px-4"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary fs-6 rounded-pill px-4"
                >
                  Add Membership
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default Membership;
